<template>
  <div class="service-container">
    <headerIndex/>
    <div class="service-content" :style="'min-height:'+min_height+'px;'">
      <div class="search-content">
        <span class="title SourceHanSansCN">{{ pName }}</span>
        <el-button round class="switch-btn" @click="switchNodes"><i class="iconfont icon-qiehuan"></i>切换节点</el-button>
        <el-input class="search-input" placeholder="请输入关键词" @keydown.enter.native="search" @input="getConnect"
                  v-model="keyword">
          <span class="red-btn SourceHanSansCN" slot="suffix" @click="search">搜索</span>
        </el-input>
      </div>
      <div class="menu-drop">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple" @click="enterpriseSearch">
              <i class="icon-red">
                <div class="icon-search"/>
              </i>
              <p class="SourceHanSansCN">企业查询</p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" @click="outsourceDemand">
              <i class="icon-red">
                <div class="icon-demand"/>
              </i>
              <p class="SourceHanSansCN">外包需求</p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" @click="bangqiCloud">
              <i class="icon-red">
                <div class="icon-cloud"/>
              </i>
              <p class="SourceHanSansCN">帮企云</p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" @click="recruit">
              <i class="icon-red">
                <div class="icon-recruit"/>
              </i>
              <p class="SourceHanSansCN">企业招聘</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="digital-content">
        <p class="title SourceHanSansCN">数字应用</p>
        <p class="tips SourceHanSansCN" @click="moreDigital">查看更多</p>
        <el-row :gutter="16">
          <el-col :span="6" v-for="(digita,indexs) of digitalList" v-if="indexs<8">
            <div class="grid-content bg-purple" @click="goodsDetails(digita)">
              <p class="small-title SourceHanSansCN">{{ digita.name }}</p>
              <el-link :underline="false" class="link-default" v-for="(link,index) of digita.tips">
                {{ link }}
                <el-divider direction="vertical" class="divider-el" v-if="index<digita.tips.length-1"/>
              </el-link>
              <p class="red-thing">{{ digita.price }}<span class="small-span">元/年起</span></p>
              <el-button type="primary" plain class="el-primary">在线咨询</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--<div class="consultant-content">
        <p class="title SourceHanSansCN">服务顾问</p>
        <p class="tips">优质服务，一对一免费咨询 专业顾问，准确高效解决问题 </p>
        <el-radio-group v-model="serviceType">
          <el-radio-button :label="radioList.id" v-for="radioList of consultantList">
            {{radioList.name }}
          </el-radio-button>
        </el-radio-group>
        <div v-for="listItem of consultantList" v-if="serviceType==listItem.id">
          <el-row :gutter="16">
            <el-col :span="8" v-for="item of listItem.list">
              <div class="grid-content bg-purple">
                <el-row>
                  <el-col :span="5">
                    <el-image :src="item.avatar" fit="cover" style="width: 60px;height: 60px;border-radius: 50%"/>
                  </el-col>
                  <el-col :span="19">
                    <p class="small-title">
                      <span class="SourceHanSansCN user-name">{{ item.name }}</span>
                      <i class="el-position">{{ item.professionalDdvisers }}</i>
                      <i class="right-icon">
                        <div class="icon-phone"/>
                      </i>
                    </p>
                    <p class="gray-p">擅长业务：
                      <span v-for="(specialized,index) of item.specializedArray">{{ specialized }}
                        <span v-if="index!=item.specializedArray.length-1">,</span>
                      </span>
                    </p>
                  </el-col>
                </el-row>
                <div class="grid-menu">
                  <div class="small-grid">
                    <p class="font-black">{{ item.alreadyServedNum }}</p>
                    <p class="font-gray">服务客户</p>
                  </div>
                  <div class="small-grid">
                    <p class="font-black">{{ item.volume }}</p>
                    <p class="font-gray">成交数量</p>
                  </div>
                  <div class="small-grid">
                    <p class="font-black">{{ item.workingYears }}</p>
                    <p class="font-gray">从业年限</p>
                  </div>
                  <div class="small-grid">
                    <p class="font-black">{{ item.favorableRate }}</p>
                    <p class="font-gray">满意度</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>-->
      <div class="outsource-content">
        <p class="title SourceHanSansCN">外包服务</p>
        <el-row :gutter="16">
          <el-col :span="8" v-for="(outsource,index) of outsourceList" v-if="index<6">
            <div class="grid-content bg-purple" @click="biddingDetails(outsource)">
              <i class="tag-1">
                <span class="tag-red">招投标</span>
                <span class="tag-white">{{ outsource.money }}{{ outsource.moneyUnit }}</span>
              </i>
              <i class="tag-2" v-if="outsource.urgent==1">急</i>
              <i class="tag-2" v-if="outsource.top==1">置顶</i>
              <p class="small-title SourceHanSansCN">{{ outsource.title }}</p>
              <p class="bottom-p">
                <span class="left-span"><i class="iconfont icon-clock"/>{{ outsource.statusFormat }}</span>
                <span class="right-span"><i class="iconfont icon-user"/>{{ outsource.nums }}人报名</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import home_footer from "@/components/footer/home_footer";
import headerIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hang";
import {pinyin} from "pinyin-pro";
import {getCategoryGoodsList, serviceAdvisor, tradingFloorsList} from '@/api/cloudServiceApi'
import cityJson from "@/static/cityJson.json";
import $store from "@/store";

export default {
  name: "serviceCloud",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 256,
      cityList: {},
      pName: '',
      keyword: '',
      showConnect: false,
      digitalList: [],
      serviceType: 1,
      consultantList: [],
      outsourceList: [],
      timer: null,
      timers: null,
      cid: 0,
    }
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    if (sessionStorage.getItem('locationInfo')){
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name){
          this.cityList = li;
        }
      }
    }
  },
  computed: {
    childNode() {
      return $store.state.childNode
    }
  },
  methods: {
    // 点击搜索
    search() {
      let routeData = this.$router.resolve({
        name: "search",
        path: '/search',
        query: { keyword: this.keyword}
      });
      window.open(routeData.href, '_blank')
      this.showConnect = false;
      this.$emit("search", this.keyword.trim());
    },
    // 输入框输入内容后
    getConnect() {
      this.showConnect = true;
      // 防抖函数
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.searchRelevantMethod();
      }, 500);
    },
    // 网络请求 获取搜索关联词
    searchRelevantMethod() {
      let obj = {keyword: this.keyword, pageLimit: 10};
      /*searchRelevant(obj).then((res) => {
        if (res.code == 200) {
          this.connections = res.content;
        }
      });*/
    },
    /*切换节点*/
    switchNodes() {
      this.$router.replace({
        path: '/ServiceCentre/switchNode',
        query: {
          city: this.cityList.key,
          cityName: this.cityList.name,
          pName: this.pName,
          type: 1
        }
      })
    },
    /*获取数字运用推荐*/
    getCategoryGoods() {
      getCategoryGoodsList({
        id: 0,
        page: 1,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.digitalList = res.content.rows;
        }
      })
    },
    /*获取推荐服务顾问*/
    getServiceAdvisor() {
      serviceAdvisor().then(res => {
        if (res.code == 200) {
          this.consultantList = res.content;
        }
      })
    },
    /*外包服务*/
    getTradingFloorsList() {
      tradingFloorsList({
        cityCode: 0,/*投标区域（全部为0*/
        endNums: 0,/*截止时间（0：全部，1：1天内，3：3天内，7：7天内）*/
        industryId: 0,/*行业id*/
        method: "desc",/*排序方法（asc：升序，desc：降序）*/
        page: 1,/*分页*/
        pageLimit: 10,/*每页条数*/
        status: 2,/*招标状态（0：全部，1：公示中，2：招标中，6：流标）*/
        type: 1,/*排序方式（1：综合排序，2：最新发布，3：投标数）*/
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0 /*用户id*/
      }).then(res => {
        if (res.code == 200) {
          this.outsourceList = res.content.rows;
        }
      })
    },
    /*外包需求*/
    outsourceDemand() {
      this.$router.replace({
        path: '/outsourceDemand/index',
        query: {
          city: this.cityList.key,
          cityName: this.cityList.name,
          pName: this.pName
        }
      })
    },
    /*企业招聘*/
    recruit() {
      this.$router.replace({path: '/recruit/index', query: {pName: this.pName}})
    },
    /*企业查询*/
    enterpriseSearch() {
      let routeData = this.$router.resolve({
        name: "enterpriseSearch",
        path: '/enterpriseSearch/index',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*帮企云*/
    bangqiCloud(){
      window.open('http://www.bangqiyun.cn', '_blank')
    },
    /*招投标详情*/
    biddingDetails(row){
      let routeData = this.$router.resolve({
        name: "BiddingDetail",
        query: {
          zid: row.zid,
        },
        path: '/serviceNet/BiddingDetails',
      });
      window.open(routeData.href, '_blank')
    },
    /*数字运用-查看更多*/
    moreDigital(){
      this.$router.push({
        path: '/cloudPlatform/platform',
        query: {
          cityName: this.childNode.name,
          cityCode: this.childNode.cityCode,
          parentCityCode: this.childNode.parentCityCode,
          pName: this.childNode.name + '企业数字化服务云平台',
          parName:this.pName
        }
      })
    },
    /*商品详情*/
    goodsDetails(row){
      this.$router.push({
        path: '/cloudPlatform/productDetails',
        query: {
          id: row.id,
          pName: this.pName
        }
      })
    },
  },
  mounted() {
    let that=this;
    that.timers = setInterval(function () {
      that.pName = that.$route.query.pName;
      if (that.pName=='') {
        that.pName = that.cityList.abridge + '企服务云'
      }
    },1000);
    this.getCategoryGoods();
    // this.getServiceAdvisor();
    this.getTradingFloorsList();
  },
  beforeDestroy() {
    clearInterval(this.timers);
  },
}
</script>
<style scoped>
.service-container >>> .service-content .search-content .el-input__prefix {
  left: 10px;
  transition: all .3s;
  font-size: 18px;
  font-weight: bold;
  padding-top: 7px;
}

.service-container >>> .service-content .search-content .el-input__suffix {
  right: 4px;
  transition: all .3s;
  pointer-events: none;
  padding-top: 4px;
}

.service-container >>> .service-content .search-content .el-input__inner:hover {
  border-color: #FE273B;
}

.service-container >>> .service-content .consultant-content .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 30px;
  margin-top: 40px;
}

.service-container >>> .service-content .consultant-content .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #ffffff;
  background-color: #FE273B;
  border-color: #FE273B;
  box-shadow: -1px 0 0 0 #fe273b;
}

.service-container >>> .service-content .consultant-content .el-radio-button__inner {
  color: #333333;
  padding: 17px 45px;
  font-size: 14px;
  border: none;
}
</style>
<style scoped lang="scss">
.service-container {
  background: #E7E9F5;

  .service-content {
    .search-content {
      background: #ffffff;
      padding: 30px 18%;
      min-width: 76rem;
      .title {
        color: #333333;
        font-size: 33px;
        cursor: pointer;
      }

      .switch-btn {
        color: #FE273B;
        background: #F5F5F5;
        border-radius: 20px;
        padding: 10px 20px;
        position: absolute;
        margin-top: 7px;
        margin-left: 30px;
        min-width: 135px;
        border: 1px solid #DDDDDD;

        .icon-qiehuan {
          padding-right: 10px;
          font-weight: bold;
        }
      }

      .search-input {
        width: 40%;
        float: right;
        margin-top: 6px;
        border: 1px solid #FE273B;
        border-radius: 6px;

        .red-btn {
          display: inline-block;
          width: 80px;
          height: 80%;
          background-color: #fd2f37;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          text-align: center;
          line-height: 33px;
          cursor: pointer;
          border-radius: 4px;
        }
      }
    }

    .menu-drop {
      background: #E7E9F5;
      padding: 20px 18%;
      min-width: 76rem;
      .el-col-6 {
        padding-left: 10px;
        padding-right: 10px;

        .bg-purple {
          background: #FFFFFF;
          border-radius: 8px;
          padding: 20px;
          text-align: center;

          p {
            color: #333333;
            font-size: 14px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding: 10px 0px 0px;
            cursor: pointer;
          }

          .icon-red {
            width: 100%;
            height: 60px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }

          .icon-search {
            background: url("~@/assets/img/cloud/search.png");
            width: 60px;
            height: 60px;
            background-size: 100% 100%;
            position: absolute;
          }

          .icon-demand {
            background: url("~@/assets/img/cloud/demand.png");
            width: 60px;
            cursor: pointer;
            height: 60px;
            background-size: 100% 100%;
            position: absolute;
          }

          .icon-cloud {
            background: url("~@/assets/img/cloud/demand.png");
            width: 60px;
            height: 60px;
            cursor: pointer;
            background-size: 100% 100%;
            position: absolute;
          }

          .icon-recruit {
            background: url("~@/assets/img/cloud/recruit.png");
            width: 60px;
            cursor: pointer;
            height: 60px;
            background-size: 100% 100%;
            position: absolute;
          }
        }
      }
    }

    .digital-content {
      background: #ffffff;
      padding: 0px 18%;
      min-width: 76rem;
      .title {
        text-align: center;
        margin-block-start: 0em;
        margin-block-end: 0em;
        padding: 40px 0px 20px;
        color: #333333;
        font-size: 24px;
        cursor: context-menu;
      }

      .tips {
        margin-block-start: 0em;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
      }

      .el-col-6 {
        margin-bottom: 20px;

        .bg-purple {
          background: #F2F3FB;
          border-radius: 8px;
          padding: 20px;

          .small-title {
            color: #333333;
            font-size: 18px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            text-align: left;
            cursor: context-menu;
          }

          .link-default {
            color: #666666;
            font-size: 12px;
          }

          .link-default:hover {
            color: #1637FF;
            font-size: 12px;
          }

          .divider-el {
            background: #666666;
          }

          .red-thing {
            color: #FE273B;
            font-size: 16px;
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding: 20px 0px 10px;
            cursor: context-menu;

            .small-span {
              font-size: 14px;
            }
          }

          .el-primary {
            font-size: 14px;
            color: #1637FF;
            background: #ffffff;
            border: 1px solid #1637FF;
            border-radius: 4px;
          }

          .el-primary:hover {
            color: #1637FF;
            background: #ecf5ff;
            border-color: #1637FF;
          }
        }
      }
    }

    .consultant-content {
      background: #E7E9F5;
      padding: 0px 18% 30px;
      min-width: 76rem;
      .title {
        text-align: center;
        margin-block-start: 0em;
        margin-block-end: 0em;
        padding: 40px 0px 20px;
        color: #333333;
        font-size: 24px;
        cursor: context-menu;
      }

      .tips {
        margin-block-start: 0em;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
      }

      .el-col-8 {
        margin-bottom: 20px;

        .bg-purple {
          background: #fff;
          border-radius: 8px;
          padding: 20px;

          .small-title {
            color: #333333;
            font-size: 18px;
            text-align: left;
            cursor: context-menu;
            margin-block-start: 0em;
            margin-block-end: 0em;

            .user-name {
              font-size: 16px;
              color: #333333;
            }

            .el-position {
              font-style: normal;
              font-size: 12px;
              color: #ffffff;
              background: #FF9600;
              padding: 3px 5px;
              border-radius: 4px;
              margin-left: 10px;
            }

            .right-icon {
              float: right;
              width: 30px;
              height: 30px;

              .icon-phone {
                background: url("~@/assets/img/cloud/dianhua.png");
                width: 30px;
                height: 30px;
                background-size: 100% 100%;
                position: absolute;
                cursor: pointer;
              }
            }
          }

          .gray-p {
            color: #999999;
            font-size: 14px;
          }

          .grid-menu {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background: #E7E9F5;
            padding: 15px 0;

            .small-grid {
              text-align: center;
              width: 85px;

              .font-black {
                color: #333333;
                font-size: 16px;
                margin-block-start: 0em;
                margin-block-end: 0em;
                font-family: 'SourceHanSansCN';
              }

              .font-gray {
                color: #666666;
                font-size: 14px;
                margin-block-start: 0em;
                margin-block-end: 0em;
              }
            }
          }
        }
      }
    }

    .outsource-content {
      background: #ffffff;
      padding: 0px 18%;
      min-width: 76rem;
      .title {
        text-align: center;
        margin-block-start: 0em;
        margin-block-end: 0em;
        padding: 40px 0px 20px;
        color: #333333;
        font-size: 24px;
        cursor: context-menu;
      }

      .el-col-8 {
        margin-bottom: 20px;

        .bg-purple {
          background: #F3F4FA;
          border-radius: 8px;
          padding: 30px 20px;

          .small-title {
            color: #333333;
            font-size: 18px;
            text-align: left;
            cursor: context-menu;
            margin-block-end: 0em;
            padding-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            word-break: break-all;

            .user-name {
              font-size: 16px;
              color: #333333;
            }

            .el-position {
              font-style: normal;
              font-size: 12px;
              color: #ffffff;
              background: #FF9600;
              padding: 3px 5px;
              border-radius: 4px;
              margin-left: 10px;
            }

            .right-icon {
              float: right;
              width: 30px;
              height: 30px;

              .icon-phone {
                background: url("~@/assets/img/cloud/dianhua.png");
                width: 30px;
                height: 30px;
                background-size: 100% 100%;
                position: absolute;
                cursor: pointer;
              }
            }
          }

          .gray-p {
            color: #999999;
            font-size: 14px;
          }

          .tag-1 {
            font-style: normal;
            cursor: pointer;

            .tag-red {
              padding: 10px;
              color: #ffffff;
              background: #FE273B;
              font-size: 14px;
              border-radius: 6px 0px 0px 6px;
              border: 1px solid #FE273B;
            }

            .tag-white {
              padding: 10px;
              color: #FE273B;
              background: white;
              font-size: 14px;
              border: 1px solid #FE273B;
              border-radius: 0px 6px 6px 0px;
            }
          }

          .tag-2 {
            font-style: normal;
            color: #FE273B;
            border-radius: 6px;
            border: 1px solid #FE273B;
            padding: 10px;
            margin-left: 20px;
            font-size: 14px;
            cursor: pointer;
          }

          .bottom-p {
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding-top: 10px;

            .left-span {
              color: #666666;
              font-size: 14px;
            }

            .right-span {
              color: #666666;
              font-size: 14px;
              float: right;
            }

            .iconfont {
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>